(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessory-compatibility-finder"] && !Shopify.designMode) return;
  try {
    
  const updateAccessoryFinder = (section) => {
    const model = section.querySelector('[data-accessory-model]')?.value || '';
    const activeType = section.querySelector('[data-accessory-type].is-active')?.dataset.accessoryType || 'all';
    const cards = section.querySelectorAll('[data-accessory-card]');
    const toolbar = section.querySelector('[data-accessory-toolbar]');
    const prompt = section.querySelector('[data-accessory-prompt]');
    const empty = section.querySelector('[data-accessory-empty]');
    const count = section.querySelector('[data-accessory-count]');
    let visibleCount = 0;

    if (!model) {
      cards.forEach((card) => { card.hidden = true; });
      if (toolbar) toolbar.hidden = true;
      if (prompt) prompt.hidden = false;
      if (empty) empty.hidden = true;
      return;
    }

    cards.forEach((card) => {
      const supportsModel = card.dataset.compatibleModels.includes(`|${model}|`);
      const supportsType = activeType === 'all' || card.dataset.cardType === activeType;
      const isVisible = supportsModel && supportsType;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (toolbar) toolbar.hidden = false;
    if (prompt) prompt.hidden = true;
    if (empty) empty.hidden = visibleCount > 0;
    if (count) {
      const label = visibleCount === 1 ? section.dataset.countSingular : section.dataset.countPlural;
      count.textContent = `${visibleCount} ${label}`;
    }
  };

  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-accessory-model]');
    if (!selector) return;
    const section = selector.closest('[data-accessory-finder]');
    if (section) updateAccessoryFinder(section);
  });

  document.addEventListener('click', (event) => {
    const typeButton = event.target.closest('[data-accessory-type]');
    if (!typeButton) return;
    const section = typeButton.closest('[data-accessory-finder]');
    if (!section) return;

    section.querySelectorAll('[data-accessory-type]').forEach((button) => {
      const isActive = button === typeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    updateAccessoryFinder(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const singaporeOffsetMs = 8 * 60 * 60 * 1000;

    const nextSingaporeMidnight = () => {
      const singaporeNow = new Date(Date.now() + singaporeOffsetMs);
      return Date.UTC(
        singaporeNow.getUTCFullYear(),
        singaporeNow.getUTCMonth(),
        singaporeNow.getUTCDate() + 1,
        0,
        0,
        0
      ) - singaporeOffsetMs;
    };

    const pad = (value) => String(value).padStart(2, '0');

    const initHero = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dailyMode = root.dataset.dailyMode === 'true';
      const configuredEnd = Number(root.dataset.endTimestamp) * 1000;
      let deadline = dailyMode ? nextSingaporeMidnight() : configuredEnd;
      if (!Number.isFinite(deadline) || deadline <= 0) deadline = Date.parse(root.dataset.endAt);
      if (!Number.isFinite(deadline)) deadline = nextSingaporeMidnight();

      const form = root.querySelector('.rr-flash-hero__form');
      const button = root.querySelector('[data-add-to-cart]');
      const mobileButton = root.querySelector('[data-mobile-buy]');
      const status = root.querySelector('[data-form-status]');

      const timerFields = {
        days: root.querySelector('[data-timer-days]'),
        hours: root.querySelector('[data-timer-hours]'),
        minutes: root.querySelector('[data-timer-minutes]'),
        seconds: root.querySelector('[data-timer-seconds]')
      };

      let timerInterval;

      const closeDrop = () => {
        const wasClosed = root.dataset.dropClosed === 'true';
        root.dataset.dropClosed = 'true';
        root.classList.add('rr-flash-hero--closed');
        root.querySelectorAll('[data-flash-live-only]').forEach((element) => {
          element.hidden = true;
        });
        root.querySelectorAll('[data-flash-closed-only]').forEach((element) => {
          element.hidden = false;
        });
        if (button) button.disabled = true;
        if (mobileButton) mobileButton.disabled = true;
        if (status) status.textContent = '';
        if (timerInterval) window.clearInterval(timerInterval);
        if (!wasClosed) document.dispatchEvent(new CustomEvent('flash-sale:closed'));
      };

      if (root.dataset.dropClosed === 'true') {
        closeDrop();
        return;
      }

      if (timerFields.seconds) {
        const updateTimer = () => {
          const distance = deadline - Date.now();
          if (distance <= 0) {
            timerFields.days.textContent = '00';
            timerFields.hours.textContent = '00';
            timerFields.minutes.textContent = '00';
            timerFields.seconds.textContent = '00';
            closeDrop();
            return;
          }

          timerFields.days.textContent = pad(Math.floor(distance / 86400000));
          timerFields.hours.textContent = pad(Math.floor((distance % 86400000) / 3600000));
          timerFields.minutes.textContent = pad(Math.floor((distance % 3600000) / 60000));
          timerFields.seconds.textContent = pad(Math.floor((distance % 60000) / 1000));
        };

        updateTimer();
        if (root.dataset.dropClosed !== 'true') timerInterval = window.setInterval(updateTimer, 1000);
      }

      const applyInventoryState = (updatedRoot) => {
        const sold = Number(updatedRoot.dataset.soldUnits);
        const limit = Number(updatedRoot.dataset.dailyLimit);
        if (!Number.isFinite(sold) || !Number.isFinite(limit) || limit < 1) return false;

        const remaining = Math.max(0, limit - sold);
        root.dataset.soldUnits = String(sold);

        if (updatedRoot.dataset.dropClosed === 'true' || remaining <= 0) {
          closeDrop();
          return true;
        }

        const progress = root.querySelector('[data-progress]');
        const progressFill = root.querySelector('[data-progress-fill]');
        const progressLabel = root.querySelector('[data-progress-label]');
        const remainingLabel = root.querySelector('[data-remaining-label]');
        const updatedProgressLabel = updatedRoot.querySelector('[data-progress-label]');
        const updatedRemainingLabel = updatedRoot.querySelector('[data-remaining-label]');
        const updatedButton = updatedRoot.querySelector('[data-add-to-cart]');

        progress?.setAttribute('aria-valuenow', String(sold));
        progressFill?.style.setProperty('--rr-flash-progress', `${(sold / limit) * 100}%`);
        if (progressLabel && updatedProgressLabel) progressLabel.textContent = updatedProgressLabel.textContent;
        if (remainingLabel && updatedRemainingLabel) remainingLabel.textContent = updatedRemainingLabel.textContent;

        const available = Boolean(updatedButton && !updatedButton.disabled && remaining > 0);
        const defaultLabel = button?.dataset.defaultLabel || mobileButton?.textContent || '';
        const soldOutLabel = button?.dataset.soldOutLabel || mobileButton?.textContent || '';
        if (button) {
          button.disabled = !available;
          button.textContent = available ? defaultLabel : soldOutLabel;
        }
        if (mobileButton) {
          mobileButton.disabled = !available;
          mobileButton.textContent = available ? defaultLabel : soldOutLabel;
        }

        return true;
      };

      const refreshInventory = async () => {
        if (root.dataset.dropClosed === 'true') return false;
        if (root.dataset.progressSource !== 'inventory' || !root.dataset.sectionId) return false;

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', root.dataset.sectionId);
          url.searchParams.set('_flash_inventory', String(Date.now()));
          const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
          if (!response.ok) return false;

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const updatedRoot = documentFragment.querySelector('[data-flash-sale-hero]');
          if (!updatedRoot) return false;
          return applyInventoryState(updatedRoot);
        } catch (error) {
          return false;
        }
      };

      if (root.dataset.progressSource === 'inventory') {
        const inventoryInterval = window.setInterval(() => {
          if (!root.isConnected || root.dataset.dropClosed === 'true') {
            window.clearInterval(inventoryInterval);
            return;
          }
          refreshInventory();
        }, 15000);
      }

      if (mobileButton && form) {
        mobileButton.addEventListener('click', () => form.requestSubmit());
      }

      if (!form || !button) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (button.disabled) return;

        button.disabled = true;
        if (mobileButton) mobileButton.disabled = true;
        status.textContent = '';

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');

          status.textContent = 'Added to cart';
          document.dispatchEvent(new CustomEvent('flash-sale:cart-added', { detail: payload }));

          window.setTimeout(async () => {
            const refreshed = await refreshInventory();
            if (refreshed) return;

            button.disabled = false;
            button.textContent = button.dataset.defaultLabel;
            if (mobileButton) {
              mobileButton.disabled = false;
              mobileButton.textContent = button.dataset.defaultLabel;
            }
          }, 900);
        } catch (error) {
          status.textContent = error.message;
          button.disabled = false;
          button.textContent = button.dataset.defaultLabel;
          if (mobileButton) mobileButton.disabled = false;
        }
      });
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-flash-sale-hero]').forEach(initHero);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const singaporeOffsetMs = 8 * 60 * 60 * 1000;

  const nextSingaporeMidnight = () => {
    const singaporeNow = new Date(Date.now() + singaporeOffsetMs);
    return Date.UTC(
      singaporeNow.getUTCFullYear(),
      singaporeNow.getUTCMonth(),
      singaporeNow.getUTCDate() + 1,
      0,
      0,
      0
    ) - singaporeOffsetMs;
  };

  const pad = (value) => String(value).padStart(2, '0');

  const initFlashSale = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const endAt = root.dataset.endAt;
    const dailyMode = root.dataset.dailyMode === 'true';
    let deadline = dailyMode ? nextSingaporeMidnight() : Date.parse(endAt);
    const timerFields = {
      days: root.querySelector('[data-timer-days]'),
      hours: root.querySelector('[data-timer-hours]'),
      minutes: root.querySelector('[data-timer-minutes]'),
      seconds: root.querySelector('[data-timer-seconds]')
    };

    if (timerFields.seconds) {
      const updateTimer = () => {
        let distance = deadline - Date.now();

        if (distance <= 0 && dailyMode) {
          deadline = nextSingaporeMidnight();
          distance = deadline - Date.now();
        }

        distance = Math.max(0, distance);
        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        timerFields.days.textContent = pad(days);
        timerFields.hours.textContent = pad(hours);
        timerFields.minutes.textContent = pad(minutes);
        timerFields.seconds.textContent = pad(seconds);
      };

      updateTimer();
      window.setInterval(updateTimer, 1000);
    }

    const form = root.querySelector('.flash-sale__form');
    const button = root.querySelector('[data-add-to-cart]');
    const mobileButton = root.querySelector('[data-mobile-buy]');
    const status = root.querySelector('[data-form-status]');

    if (mobileButton && form) {
      mobileButton.addEventListener('click', () => form.requestSubmit());
    }

    if (!form || !button) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (button.disabled) return;

      button.disabled = true;
      if (mobileButton) mobileButton.disabled = true;
      button.textContent = button.dataset.loadingLabel;
      status.textContent = '';

      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const payload = await response.json();

        if (!response.ok) {
          throw new Error(payload.description || payload.message || 'Unable to add this item.');
        }

        const limit = Number(root.dataset.dailyLimit);
        const sold = Math.min(limit, Number(root.dataset.soldUnits) + 1);
        const remaining = Math.max(0, limit - sold);
        root.dataset.soldUnits = String(sold);

        const progress = root.querySelector('[data-progress]');
        const progressFill = root.querySelector('[data-progress-fill]');
        const progressLabel = root.querySelector('[data-progress-label]');
        const remainingLabel = root.querySelector('[data-remaining-label]');
        progress?.setAttribute('aria-valuenow', String(sold));
        progressFill?.style.setProperty('--flash-progress', `${(sold / limit) * 100}%`);

        if (progressLabel) {
          progressLabel.textContent = progressLabel.textContent.replace(/^\d+/, String(sold));
        }

        if (remainingLabel) {
          remainingLabel.textContent = remainingLabel.textContent.replace(/\d+/, String(remaining));
        }

        button.textContent = button.dataset.addedLabel;
        status.textContent = payload.product_title || '';
        document.dispatchEvent(new CustomEvent('flash-sale:cart-added', { detail: payload }));

        window.setTimeout(() => {
          if (remaining === 0) {
            button.textContent = button.dataset.soldOutLabel;
            if (mobileButton) mobileButton.textContent = button.dataset.soldOutLabel;
            return;
          }

          button.disabled = false;
          button.textContent = button.dataset.defaultLabel;
          if (mobileButton) mobileButton.disabled = false;
        }, 1400);
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
        button.textContent = button.dataset.defaultLabel;
        if (mobileButton) mobileButton.disabled = false;
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-flash-sale]').forEach(initFlashSale);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-auction"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floating-auction')) {
    customElements.define('floating-auction', class extends HTMLElement {
      connectedCallback() {
        this.updateVisibility();
        this.visibilityTimer = window.setInterval(() => this.updateVisibility(), 900000);

        this.querySelector('[data-auction-link]')?.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'auction_coin_click' });
        });
      }

      disconnectedCallback() {
        window.clearInterval(this.visibilityTimer);
      }

      updateVisibility() {
        if (window.Shopify?.designMode) {
          this.classList.remove('is-hidden');
          return;
        }

        const singaporeDay = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Asia/Singapore',
          weekday: 'short'
        }).format(new Date());
        const isAuctionDay = ['Thu', 'Fri', 'Sat', 'Sun'].includes(singaporeDay);

        this.classList.toggle('is-hidden', !isAuctionDay);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floating-contact')) {
    customElements.define('floating-contact', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');

        document.addEventListener('click', (event) => {
          if (this.details.open && !this.contains(event.target)) this.details.open = false;
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.summary.focus();
          }
        });

        this.querySelectorAll('[data-contact-action]').forEach((link) => {
          link.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: `${link.dataset.contactAction}_click` });
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initComparison = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const maxProducts = Number(root.dataset.maxProducts || 3);
    const picker = root.querySelector('[data-product-picker]');
    const productOptions = Array.from(root.querySelectorAll('[data-product-option]'));
    const categories = [...new Set(productOptions.map((option) => option.dataset.category))];
    const url = new URL(window.location.href);
    const requestedCategory = url.searchParams.get('compare_category');
    let activeCategory = categories.includes(requestedCategory) ? requestedCategory : root.dataset.defaultCategory;
    const selected = {};
    let draftSelection = [];
    let pageScrollY = 0;
    let pageScrollLocked = false;
    let previousBodyStyles = {};
    const themeHeader = document.querySelector('.section-header');

    const updateStickyHeaderOffset = () => {
      if (!themeHeader) return;
      const isSticky = themeHeader.classList.contains('shopify-section-header-sticky');
      const isHidden = themeHeader.classList.contains('shopify-section-header-hidden');
      const offset = isSticky && !isHidden ? themeHeader.offsetHeight : 0;
      root.style.setProperty('--rr-compare-header-offset', `${offset}px`);
    };

    const headerClassObserver = themeHeader
      ? new MutationObserver(updateStickyHeaderOffset)
      : null;
    const headerSizeObserver = themeHeader && 'ResizeObserver' in window
      ? new ResizeObserver(updateStickyHeaderOffset)
      : null;

    if (themeHeader) {
      headerClassObserver.observe(themeHeader, { attributes: true, attributeFilter: ['class'] });
      headerSizeObserver?.observe(themeHeader);
      window.addEventListener('resize', updateStickyHeaderOffset, { passive: true });
      updateStickyHeaderOffset();
    }

    const lockPageScroll = () => {
      if (pageScrollLocked) return;
      pageScrollY = window.scrollY;
      previousBodyStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        overflow: document.body.style.overflow
      };
      document.documentElement.classList.add('rr-compare-picker-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${pageScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      pageScrollLocked = true;
    };

    const unlockPageScroll = () => {
      if (!pageScrollLocked) return;
      document.documentElement.classList.remove('rr-compare-picker-open');
      Object.entries(previousBodyStyles).forEach(([property, value]) => {
        document.body.style[property] = value;
      });
      pageScrollLocked = false;
      window.scrollTo(0, pageScrollY);
    };

    const poolFor = (category) => productOptions
      .filter((option) => option.dataset.category === category)
      .map((option) => option.dataset.productHandle);

    categories.forEach((category) => {
      const pool = poolFor(category);
      const requested = category === activeCategory
        ? (url.searchParams.get('compare') || '').split(',').filter((handle) => pool.includes(handle))
        : [];
      selected[category] = [...new Set(requested)].slice(0, maxProducts);
      if (selected[category].length < Math.min(2, pool.length)) {
        selected[category] = pool.slice(0, Math.min(2, pool.length));
      }
    });

    const track = (eventName, detail = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    };

    const updateUrl = () => {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('compare_category', activeCategory);
      nextUrl.searchParams.set('compare', selected[activeCategory].join(','));
      window.history.replaceState({}, '', nextUrl);
    };

    const updateDifferences = () => {
      const panel = root.querySelector(`[data-category-panel="${activeCategory}"]`);
      const differencesOnly = root.querySelector('[data-differences-only]')?.checked;
      if (!panel) return;

      panel.querySelectorAll('[data-spec-row]').forEach((row) => {
        const values = Array.from(row.querySelectorAll('[data-product-column]:not([hidden])'))
          .map((cell) => cell.dataset.value.trim().toLowerCase());
        const different = new Set(values).size > 1;
        row.dataset.different = String(different);
        row.hidden = Boolean(differencesOnly && !different);
      });

      panel.querySelectorAll('[data-spec-group]').forEach((group) => {
        const hasVisibleRows = Array.from(group.querySelectorAll('[data-spec-row]')).some((row) => !row.hidden);
        group.hidden = !hasVisibleRows;
      });
    };

    const render = ({ announce = true } = {}) => {
      root.querySelectorAll('[data-category-tab]').forEach((tab) => {
        const isActive = tab.dataset.categoryTab === activeCategory;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      root.querySelectorAll('[data-category-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.categoryPanel !== activeCategory;
      });

      root.querySelectorAll('[data-product-column]').forEach((column) => {
        const visible = column.dataset.category === activeCategory && selected[activeCategory].includes(column.dataset.productHandle);
        column.hidden = !visible;
        const removeButton = column.querySelector('[data-remove-product]');
        if (removeButton) removeButton.hidden = !visible || selected[activeCategory].length <= 2;
      });

      root.querySelectorAll('[data-comparison-stage]').forEach((stage) => {
        stage.style.setProperty('--compare-count', String(Math.max(selected[activeCategory].length, 1)));
      });

      const status = root.querySelector('[data-comparison-status]');
      if (status && announce) {
        status.textContent = root.dataset.selectedLabel.replace('__count__', String(selected[activeCategory].length));
      }

      updateDifferences();
      updateUrl();
    };

    const renderPicker = () => {
      const query = root.querySelector('[data-picker-search]')?.value.trim().toLowerCase() || '';
      let visibleCount = 0;

      productOptions.forEach((option) => {
        const inCategory = option.dataset.category === activeCategory;
        const matchesSearch = option.dataset.productTitle.toLowerCase().includes(query);
        const isSelected = draftSelection.includes(option.dataset.productHandle);
        option.hidden = !(inCategory && matchesSearch);
        option.setAttribute('aria-pressed', String(isSelected));
        option.disabled = !isSelected && draftSelection.length >= maxProducts;
        if (!option.hidden) visibleCount += 1;
      });

      const count = root.querySelector('[data-picker-count]');
      const apply = root.querySelector('[data-apply-products]');
      const empty = root.querySelector('[data-picker-empty]');
      if (count) count.textContent = root.dataset.selectedLabel.replace('__count__', String(draftSelection.length));
      if (apply) apply.disabled = draftSelection.length < Math.min(2, poolFor(activeCategory).length);
      if (empty) empty.hidden = visibleCount > 0;
    };

    root.querySelectorAll('[data-category-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        activeCategory = tab.dataset.categoryTab;
        render();
        track('compare_category_changed', { compare_category: activeCategory });
      });
    });

    root.querySelector('[data-open-picker]')?.addEventListener('click', () => {
      draftSelection = [...selected[activeCategory]];
      const search = root.querySelector('[data-picker-search]');
      if (search) search.value = '';
      renderPicker();
      if (picker && !picker.open) {
        lockPageScroll();
        picker.showModal();
        window.requestAnimationFrame(() => search?.focus({ preventScroll: true }));
      }
    });

    productOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const handle = option.dataset.productHandle;
        if (draftSelection.includes(handle)) {
          draftSelection = draftSelection.filter((item) => item !== handle);
        } else if (draftSelection.length < maxProducts) {
          draftSelection.push(handle);
        }
        renderPicker();
      });
    });

    root.querySelector('[data-picker-search]')?.addEventListener('input', renderPicker);

    root.querySelector('[data-apply-products]')?.addEventListener('click', () => {
      if (draftSelection.length < Math.min(2, poolFor(activeCategory).length)) {
        const status = root.querySelector('[data-comparison-status]');
        if (status) status.textContent = root.dataset.minimumLabel;
        return;
      }
      selected[activeCategory] = [...draftSelection];
      picker?.close();
      render();
      track('compare_products_applied', {
        compare_category: activeCategory,
        compare_products: selected[activeCategory].join(',')
      });
    });

    root.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-product]');
      if (!removeButton) return;
      const minimum = Math.min(2, poolFor(activeCategory).length);
      if (selected[activeCategory].length <= minimum) {
        const status = root.querySelector('[data-comparison-status]');
        if (status) status.textContent = root.dataset.minimumLabel;
        return;
      }
      selected[activeCategory] = selected[activeCategory].filter((handle) => handle !== removeButton.dataset.removeProduct);
      render();
    });

    root.querySelector('[data-differences-only]')?.addEventListener('change', (event) => {
      updateDifferences();
      track('compare_differences_toggled', { enabled: event.target.checked });
    });

    root.querySelector('[data-share-comparison]')?.addEventListener('click', async () => {
      updateUrl();
      const shareData = { title: document.title, url: window.location.href };
      try {
        if (navigator.share) {
          await navigator.share(shareData);
        } else {
          await navigator.clipboard.writeText(window.location.href);
          const status = root.querySelector('[data-comparison-status]');
          if (status) status.textContent = root.dataset.linkCopiedLabel;
        }
        track('compare_shared', { compare_category: activeCategory });
      } catch (error) {
        if (error.name !== 'AbortError') {
          const status = root.querySelector('[data-comparison-status]');
          if (status) status.textContent = window.location.href;
        }
      }
    });

    picker?.addEventListener('click', (event) => {
      if (event.target === picker) picker.close();
    });

    picker?.addEventListener('close', unlockPageScroll);

    const cleanupComparison = (event) => {
      if (!event.target.contains(root)) return;
      headerClassObserver?.disconnect();
      headerSizeObserver?.disconnect();
      window.removeEventListener('resize', updateStickyHeaderOffset);
      document.removeEventListener('shopify:section:unload', cleanupComparison);
    };
    document.addEventListener('shopify:section:unload', cleanupComparison);

    render({ announce: false });
  };

  const initAllComparisons = (scope = document) => {
    scope.querySelectorAll('[data-product-comparison]').forEach(initComparison);
  };

  initAllComparisons();
  document.addEventListener('shopify:section:load', (event) => initAllComparisons(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roadshow-landing-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const filterButton = event.target.closest('[data-roadshow-filter]');
    if (!filterButton) return;

    const section = filterButton.closest('[data-roadshow-landing]');
    if (!section) return;

    const selectedSeries = filterButton.dataset.roadshowFilter;
    const cards = section.querySelectorAll('[data-roadshow-series]');
    let visibleCount = 0;

    section.querySelectorAll('[data-roadshow-filter]').forEach((button) => {
      const isActive = button === filterButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    cards.forEach((card) => {
      const isVisible = selectedSeries === 'all' || card.dataset.roadshowSeries === selectedSeries;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    const count = section.querySelector('[data-roadshow-count]');
    if (count) count.textContent = `${visibleCount} ${visibleCount === 1 ? 'model' : 'models'}`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roadshow-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-roadshow-thumb]');
    if (!thumb) return;

    const section = thumb.closest('.roadshow-product');
    const image = section?.querySelector('.roadshow-product__main-image');
    if (!image) return;

    image.style.opacity = '0';
    window.setTimeout(() => {
      image.src = thumb.dataset.imageSrc;
      image.srcset = '';
      image.alt = thumb.dataset.imageAlt || '';
      image.style.opacity = '1';
    }, 120);

    section.querySelectorAll('[data-roadshow-thumb]').forEach((button) => {
      const active = button === thumb;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-roadshow-variant]');
    if (!select) return;

    const section = select.closest('.roadshow-product');
    const option = select.selectedOptions[0];
    const price = section?.querySelector('[data-roadshow-price]');
    const compare = section?.querySelector('[data-roadshow-compare]');
    const submit = section?.querySelector('[data-roadshow-submit]');

    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = option.dataset.onSale !== 'true';
    }
    if (submit) submit.disabled = option.dataset.available !== 'true';
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.roadshow-product__form');
    if (!form) return;

    event.preventDefault();

    const section = form.closest('[data-roadshow-section]');
    const serviceSelect = form.querySelector('[data-roadshow-service]');
    const submit = form.querySelector('[data-roadshow-submit]');
    const submitLabel = form.querySelector('[data-roadshow-submit-label]');
    const errorMessage = form.querySelector('[data-roadshow-form-error]');
    const originalLabel = submitLabel?.textContent;

    if (!section || !serviceSelect || !submit) return;

    if (errorMessage) {
      errorMessage.hidden = true;
      errorMessage.textContent = '';
    }

    submit.disabled = true;
    if (submitLabel) submitLabel.textContent = submit.dataset.loadingLabel || 'Adding…';

    try {
      const formData = new FormData(form);
      const variantId = Number(formData.get('id'));
      const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
      const selectedService = serviceSelect.selectedOptions[0];
      const properties = {};

      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = String(value);
      });

      properties['Roadshow service'] = selectedService.dataset.serviceLabel || selectedService.textContent.trim();

      const items = [{ id: variantId, quantity, properties }];

      if (serviceSelect.value === 'addon') {
        const serviceVariantId = Number(section.dataset.serviceVariantId);
        if (!serviceVariantId) throw new Error(section.dataset.cartError);

        items.push({
          id: serviceVariantId,
          quantity,
          properties: {
            'Covered product': section.dataset.productTitle,
            'Delivery Schedule': properties['Delivery Schedule'],
            'Promoter': properties.Promoter
          }
        });
      }

      const response = await fetch(section.dataset.cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const responseBody = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(responseBody.description || responseBody.message || section.dataset.cartError);
      }

      const orderAttributes = {
        'Delivery Schedule': properties['Delivery Schedule'],
        'Promoter': properties.Promoter
      };

      const attributesResponse = await fetch(section.dataset.cartUpdateUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: orderAttributes })
      });

      if (!attributesResponse.ok) {
        console.warn('Roadshow order attributes could not be saved. The line-item properties remain attached to the product.');
      }

      window.location.assign(section.dataset.cartUrl);
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error.message || section.dataset.cartError;
        errorMessage.hidden = false;
      }
      submit.disabled = false;
      if (submitLabel) submitLabel.textContent = originalLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-auction-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.querySelector('.rr-auction-product');

  if (!section || section.dataset.auctionUxReady === 'true') return;

  section.dataset.auctionUxReady = 'true';
  let dialogWasOpen = false;
  let dialogTrigger = null;

  const registration = section.querySelector('[data-auction-mobile-registration]');

  if (registration) {
    const customerEmail = registration.dataset.customerEmail?.trim();
    let formWasSubmitted = false;
    let reloadScheduled = false;
    let observedFormRoot = null;
    let registrationObserver;

    const setNativeValue = (input, value) => {
      const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
      setter?.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const prepareRegistrationForm = () => {
      const formEmbed = registration.querySelector('shopify-forms-embed');
      const formRoot = formEmbed?.shadowRoot || registration;
      const form = formRoot.querySelector('[data-testid="form"]');
      const emailInput = formRoot.querySelector('[data-testid="field-email"]');
      const appHeading = formRoot.querySelector('h2');

      if (formEmbed?.shadowRoot && observedFormRoot !== formEmbed.shadowRoot) {
        observedFormRoot = formEmbed.shadowRoot;
        registrationObserver.observe(observedFormRoot, { childList: true, subtree: true });
      }

      if (appHeading?.parentElement) {
        appHeading.parentElement.setAttribute('data-auction-form-intro', '');
        appHeading.parentElement.style.setProperty('display', 'none', 'important');
      }

      if (form && form.dataset.auctionSubmitReady !== 'true') {
        form.dataset.auctionSubmitReady = 'true';
        form.addEventListener('submit', () => { formWasSubmitted = true; });
      }

      if (emailInput) {
        if (customerEmail && emailInput.value !== customerEmail) setNativeValue(emailInput, customerEmail);
        const emailField = emailInput.closest('div');

        if (emailField) {
          emailField.setAttribute('hidden', '');
          emailField.setAttribute('aria-hidden', 'true');
          emailField.style.setProperty('display', 'none', 'important');
        }
      }

      if (formWasSubmitted && !form && !reloadScheduled) {
        reloadScheduled = true;
        window.setTimeout(() => window.location.reload(), 1400);
      }
    };

    registrationObserver = new MutationObserver(prepareRegistrationForm);
    registrationObserver.observe(registration, { childList: true, subtree: true });
    prepareRegistrationForm();
  }

  const gallery = section.querySelector('[data-auction-gallery]');

  if (gallery) {
    const stage = gallery.querySelector('.rr-auction-product__gallery-stage');
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    let activeIndex = 0;
    let scrollFrame = null;

    const updateGallery = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      const mediaRatio = Number(slides[activeIndex]?.dataset.mediaRatio) || 1;
      const displayRatio = Math.min(1.35, Math.max(.78, mediaRatio));

      stage?.style.setProperty('--rr-gallery-ratio', String(displayRatio));

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.toggleAttribute('inert', !isActive);

        if (!isActive) slide.querySelectorAll('video').forEach((video) => video.pause());
      });

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (current) current.textContent = String(activeIndex + 1);
    };

    const showMedia = (index) => {
      if (!track || slides.length < 2) return;

      const wrappedIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[wrappedIndex].offsetLeft, behavior: 'smooth' });
      updateGallery(wrappedIndex);
      thumbnails[wrappedIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    previous?.addEventListener('click', () => showMedia(activeIndex - 1));
    next?.addEventListener('click', () => showMedia(activeIndex + 1));

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showMedia(Number(thumbnail.dataset.galleryThumbnail)));
    });

    track?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showMedia(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    track?.addEventListener('scroll', () => {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);

      scrollFrame = window.requestAnimationFrame(() => {
        const nearestIndex = slides.reduce((nearest, slide, index) => {
          const nearestDistance = Math.abs(slides[nearest].offsetLeft - track.scrollLeft);
          const slideDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
          return slideDistance < nearestDistance ? index : nearest;
        }, 0);

        if (nearestIndex !== activeIndex) updateGallery(nearestIndex);
      });
    }, { passive: true });

    updateGallery(0);
  }

  const enhanceWidget = () => {
    const widget = section.querySelector('#codeBlock-auction-widget');
    const bidCount = section.querySelector('#codeBlock-no-of-bids');
    const viewAll = section.querySelector('#view-all-section');
    const countdown = section.querySelector('#auction-today-countdown');

    if (!widget) return;

    widget.classList.add('rr-auction-widget--enhanced');

    if (bidCount && viewAll) {
      const bidRow = bidCount.closest('.auction-details-list-item');

      if (bidRow && viewAll.parentElement !== bidRow) {
        bidRow.classList.add('rr-auction-bids-row');
        bidRow.append(viewAll);
      }
    }

    if (countdown) countdown.setAttribute('aria-live', 'off');

    section.querySelectorAll('.codeBlock-bid-response, .codeBlock-auction-is-highest-bidder, .codeBlock-auction-is-outbid-message, .codeBlock-auction-automatic-bidding-response').forEach((message) => {
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
    });

    const viewAllButton = section.querySelector('.view-all-bids-button');
    if (viewAllButton) viewAllButton.setAttribute('type', 'button');
  };

  const enhanceDialog = () => {
    const modal = document.querySelector('.tingle-modal--visible');

    if (!modal || !dialogTrigger) {
      if (dialogWasOpen && dialogTrigger && document.contains(dialogTrigger)) dialogTrigger.focus();
      dialogWasOpen = false;
      return;
    }

    const box = modal.querySelector('.tingle-modal-box');
    const content = modal.querySelector('.tingle-modal-box__content');
    const closeButton = modal.querySelector('.tingle-modal__close');
    const heading = content?.querySelector('h1, h2, h3, h4, h5, h6');
    const table = content?.querySelector('table');
    const firstEnhancement = modal.dataset.auctionDialogReady !== 'true';

    modal.dataset.auctionDialogReady = 'true';
    modal.classList.add('rr-auction-modal');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    if (heading) {
      if (!heading.id) heading.id = 'rr-auction-dialog-title';
      modal.setAttribute('aria-labelledby', heading.id);
    }

    if (box && closeButton && closeButton.parentElement !== box) box.prepend(closeButton);

    if (closeButton) {
      closeButton.setAttribute('type', 'button');
      closeButton.setAttribute('aria-label', section.dataset.dialogCloseLabel);
    }

    if (table) {
      const rows = [...table.rows];
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailColumn = rows.reduce((found, row) => {
        if (found > -1) return found;
        return [...row.cells].findIndex((cell) => emailPattern.test(cell.textContent.trim()));
      }, -1);

      if (emailColumn > -1) {
        const nameColumn = emailColumn - 1;
        const nameHeading = table.querySelector(`thead tr > *:nth-child(${nameColumn + 1})`);

        if (nameHeading) nameHeading.textContent = section.dataset.bidderLabel;

        table.querySelectorAll('tbody tr').forEach((row) => {
          const nameCell = row.cells[nameColumn];
          const fullName = nameCell?.textContent.trim() || '';

          if (nameCell && fullName) {
            const nameParts = fullName.split(/\s+/);
            const visibleName = nameParts.length > 1 ? nameParts[0] : fullName.slice(0, Math.max(1, fullName.length - 3));
            nameCell.textContent = `${visibleName} XXX`;
          }
        });

        rows.forEach((row) => row.cells[emailColumn]?.remove());
      }

      table.classList.add('rr-auction-history-table');
      const labels = [...table.querySelectorAll('thead th')].map((cell) => cell.textContent.trim());

      table.querySelectorAll('tbody tr').forEach((row) => {
        [...row.cells].forEach((cell, index) => cell.setAttribute('data-label', labels[index] || ''));
      });
    }

    if (firstEnhancement) {
      dialogWasOpen = true;
      window.requestAnimationFrame(() => closeButton?.focus());
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.view-all-bids-button');

    if (!button || !section.contains(button)) return;

    dialogTrigger = button;
    window.setTimeout(enhanceDialog, 0);
  });

  const observer = new MutationObserver(enhanceWidget);
  const dialogObserver = new MutationObserver(enhanceDialog);
  observer.observe(section, { childList: true, subtree: true });
  dialogObserver.observe(document.body, { childList: true, subtree: true });
  enhanceWidget();
})();

(() => {
  const maskWinner = (value, fallback) => {
    const name = String(value || '').trim();
    if (!name || name.includes('@')) return fallback;
    return Array.from(name)[0] + '***';
  };
  const isMatchingWinner = (bid, auctionId, productId, variantId) =>
    bid.status === 'WINNER' && String(bid.auctionId || bid.auction?.id) === String(auctionId)
    && String(bid.productId) === String(productId) && String(bid.variantId) === String(variantId);
  const loadWinners = async (panel, auction, productId, variantId) => {
    const winners = new Map();
    for (let page = 0; page < 20; page += 1) {
      const params = new URLSearchParams({shop:panel.dataset.shop,type:'ALL',productId,variantId,customerId:'0',auctionId:String(auction.id),status:'WINNER',page:String(page),size:'50',sort:'amount,desc'});
      const response = await fetch('/apps/auction-today/customer-portal/api/auction-biddings/by-shop?' + params, {credentials:'omit',signal:AbortSignal.timeout(10000),cache:'no-store'});
      if (!response.ok) throw new Error('Result unavailable');
      const bids = await response.json();
      if (!Array.isArray(bids)) throw new Error('Invalid result');
      bids.filter(bid => isMatchingWinner(bid,auction.id,productId,variantId)).forEach(bid => winners.set(String(bid.id), {name:maskWinner(bid.customerName,panel.dataset.bidder),amount:bid.amount,currency:bid.currency}));
      const total = Number(response.headers.get('x-total-count'));
      if (bids.length < 50 || (total > 0 && (page+1)*50 >= total)) return [...winners.values()];
    }
    throw new Error('Incomplete result');
  };
  const init = (section) => {
    const panel = section.querySelector('[data-auction-result]');
    if (!panel || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    let busy=false, lastRequest=0, lastAuctionId=null;
    const refresh = async () => {
      if (!section.isConnected || busy) return;
      const utils=window.CodeBlockUtils;
      const anchor=section.querySelector('.rr-auction-product__widget-anchor');
      if (!utils?.detectAuction || !utils?.isExpired || !anchor || !window.codeBlockAuction?.auctions) return;
      const productId=anchor.dataset.productId, variantId=anchor.dataset.variantId;
      let auction=utils.detectAuction(productId,variantId);
      if (!auction) auction=window.codeBlockAuction.auctions
        .filter(entry => !entry.applyAcrossStore && entry.products?.some(product => String(product.productId) === productId && String(product.variantId) === variantId))
        .sort((a,b)=>Number(b.id)-Number(a.id))[0];
      const ended=auction && (auction.status === 'END' || utils.isExpired(auction));
      panel.hidden=!ended;
      section.classList.toggle('rr-auction-product--ended',Boolean(ended));
      if (!ended) { lastAuctionId=null; return; }
      if (Date.now()-lastRequest < 60000 && lastAuctionId === auction.id) return;
      busy=true; lastRequest=Date.now(); lastAuctionId=auction.id;
      const heading=panel.querySelector('[data-result-heading]');
      const message=panel.querySelector('[data-result-message]');
      const list=panel.querySelector('[data-result-winners]');
      const privacy=panel.querySelector('[data-result-privacy]');
      try {
        const winners=await loadWinners(panel,auction,productId,variantId);
        const fragment=document.createDocumentFragment();
        winners.forEach(winner => {
          const row=document.createElement('div'); row.className='rr-auction-result__winner';
          let amount='';
          if (winner.amount != null && Number.isFinite(Number(winner.amount)) && /^[A-Z]{3}$/.test(winner.currency || '')) {
            amount=new Intl.NumberFormat(panel.dataset.locale || 'en',{style:'currency',currency:winner.currency,currencyDisplay:'code'}).format(Number(winner.amount));
          }
          [[panel.dataset.winnerLabel,winner.name],[panel.dataset.amountLabel,amount]].filter(([,value])=>value).forEach(([label,value])=>{
            const group=document.createElement('div'),caption=document.createElement('span'),text=document.createElement('strong');
            caption.textContent=label; text.textContent=value; group.append(caption,text); row.append(group);
          });
          fragment.append(row);
        });
        list.replaceChildren(fragment); list.hidden=!winners.length; privacy.hidden=!winners.length;
        heading.textContent=winners.length ? panel.dataset.declared : panel.dataset.pending;
        message.hidden=Boolean(winners.length); message.textContent=panel.dataset.pendingText;
      } catch {
        if (list.hidden) { heading.textContent=panel.dataset.pending; message.hidden=false; message.textContent=panel.dataset.unavailable; }
      } finally { busy=false; }
    };
    refresh();
    let attempts=0;
    const startup=setInterval(()=>{refresh();if(++attempts>=40 || !section.isConnected) clearInterval(startup);},500);
    const timer=setInterval(()=>{if (!section.isConnected) clearInterval(timer);else if(!document.hidden) refresh();},30000);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
  };
  document.querySelectorAll('.rr-auction-product').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.rr-auction-product').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roborock-events-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.roborockCampaignVariantPricingBound) {
    window.roborockCampaignVariantPricingBound = true;
    document.addEventListener('change', (event) => {
      const selector = event.target.closest('.rr-campaign-card__select');
      if (!selector) return;

      const card = selector.closest('.rr-campaign-card');
      const selectedVariant = selector.selectedOptions[0];
      if (!card || !selectedVariant) return;

      const price = card.querySelector('[data-campaign-price]');
      const comparePrice = card.querySelector('[data-campaign-compare-price]');
      const savings = card.querySelector('[data-campaign-savings]');
      const button = card.querySelector('.rr-campaign-card__button');
      const savingsPercent = Number(selectedVariant.dataset.savingsPercent || 0);
      const available = selectedVariant.dataset.available === 'true';

      if (price) price.textContent = selectedVariant.dataset.price || '';

      if (comparePrice) {
        comparePrice.textContent = selectedVariant.dataset.comparePrice || '';
        comparePrice.hidden = !selectedVariant.dataset.comparePrice;
      }

      if (savings) {
        savings.textContent = `${savings.dataset.label} ${savingsPercent}%`;
        savings.hidden = savingsPercent <= 0;
      }

      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
